module.exports = __webpack_public_path__ + "logo.png?a89eef68f2e9882a51e235c65498ef4e";


//////////////////
// WEBPACK FOOTER
// ./img/logo.png
// module id = 34
// module chunks = 0